import React, { useMemo } from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss"
import { FormattedMessage } from "react-intl";
import ProductSizeModule from "../../../module/size/product-size-module";
import SizeCountrySelector from "../../../../components/size-country-selector"
import SizeCollectionSelector from "../size-collection-selector";
import QuickShippingTip from "../quick-shipping";
import { useSelector } from "react-redux";

const ProductSize = props =>{
    useStyles(classes);
    const { productHooks } = props;
    const {
        isBeautyMakeup,
        productVO,
        selectedVariant,
        selectedProduct,
        selectVariant,
        hiddenSizeCollectionSelector=false
    } = productHooks;

    const global = useSelector(state => state.global)
    const isOv = v => v?.domesticDelivery.enabled;

    const overseaSizeList = useMemo(() => {
        const getSizeLabel = size => {
            const countries = selectedProduct?.sizeChart2?.countryAndSizesList?.[0]?.map(c => c.country)
            const sizeDefaultCountry = countries?.find(c => c === global?.sizeDefaultCountry) || selectedProduct?.sizeChart2?.defaultCountry
            const sizes = selectedProduct?.sizeChart2?.countryAndSizesList?.find?.(s => s[0]?.size === size)
            if(sizes?.length > 0){
                return sizes?.find(s => s.country === sizeDefaultCountry)?.size || size
            }
            return size
        }
        let overseaV = selectedProduct?.variants?.map(v => isOv(v)? v: '')
        const overseaSize = overseaV?.filter(o => !!o)?.map(o => getSizeLabel(o?.size))
        return overseaSize
    }, [global, selectedProduct])

    return <React.Fragment>
        {
            !isBeautyMakeup && !(selectedProduct?.variants?.length === 1 && !!!selectedProduct?.variants?.[0]?.size) && <div className={`${productVO?.products?.length > 1?classes.SizeProduct:""} ${classes.PPickContainer}`}>
                <div className={classes.Hd}>
                    {
                        selectedProduct?.sizeChart2 ? <React.Fragment>
                            <span className={classes.FontMedium}><FormattedMessage id="size" defaultMessage={'Size'}/>&nbsp;</span>
                            <SizeCountrySelector sizeChart2={selectedProduct?.sizeChart2} />
                        </React.Fragment> : <span className={classes.FontMedium}><FormattedMessage id="size" defaultMessage={'Size'}/>:</span>
                    }
                </div>

                <div className={classes.Bd}>
                    <ProductSizeModule isDetail={true} selectedVariant={selectedVariant} selectedProduct={selectedProduct} selectVariant={selectVariant} productVO={productVO}/>
                </div>

                {
                    // 海外仓子产品提示 quick shipping
                    overseaSizeList?.length > 0 &&
                    <QuickShippingTip overseaSizeList={overseaSizeList}/>
                }

                {
                    // 2是衣服 1是鞋子
                    (selectedProduct?.sizeChart2?.id == 2 || selectedProduct?.sizeChart2?.id == 1) && !selectedProduct?.hasDoubleSize &&!hiddenSizeCollectionSelector&& <React.Fragment>
                        <SizeCollectionSelector
                            productId={selectedProduct.id}
                            product={selectedProduct}
                            smallMarginTop={overseaSizeList?.length > 0}
                        />
                    </React.Fragment>
                }
            </div>
        }
    </React.Fragment>
}

export default ProductSize;